export const OSO_LIGHT_BLUE = "#e3f6f5";
export const OSO_SUCCESS = "#24da78";
